import React from "react";
import { useHistory } from "react-router";
import { Routes } from "../../root/routes";
import { WorkflowSetupPageWrapper } from "./WorkflowSetupPageWrapper";

type WithdrawalOfConsentInstructionsPageProps = {
  embedded?: boolean;
};

export const WithdrawalOfConsentInstructionsPage = ({
  embedded = false,
}: WithdrawalOfConsentInstructionsPageProps = {}) => {
  const history = useHistory();
  const pageContent = <></>;

  if (embedded) {
    return pageContent;
  }

  return (
    <WorkflowSetupPageWrapper
      selectedTabKey="withdrawal-of-consent-request"
      nextOnClick={() =>
        history.push(Routes.organization.requestHandling.requestToProfilingInformation)
      }
      nextDisabled={false}
      nextContent="Next"
    >
      {pageContent}
    </WorkflowSetupPageWrapper>
  );
};
